// Each service serves a flat catalog ({ code, name, group_key, group,
// action?, description?, grant, privacy }); the page groups it by group_key,
// the area's fixed id (also used in links: ?group_key=), keeping the order the
// services declare it in. group is the label, already translated.
export function groupCatalog(entries) {
  const groups = new Map();
  entries.forEach((entry) => {
    const key = entry.group_key;
    if (!groups.has(key)) groups.set(key, { key, group: entry.group, permissions: [] });
    groups.get(key).permissions.push(entry);
  });
  return Array.from(groups.values());
}

export function grantedCount(permissions, selectedCodes) {
  const selected = new Set(selectedCodes);
  return permissions.filter((permission) => selected.has(permission.code)).length;
}

// Only catalog codes are added or removed, so codes outside the loaded
// catalogs (a service that's down, a legacy code) stay on the role.
export function toggleCodes(selectedCodes, codes, checked) {
  const selected = new Set(selectedCodes);
  codes.forEach((code) => (checked ? selected.add(code) : selected.delete(code)));
  return Array.from(selected);
}
